<template>
  <div>
    <CardView>
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <FormTaskDefinition @update="create"
            ></FormTaskDefinition>
          </div>
          <div class="col">
            <subtask-list :subtasks="subtasks"></subtask-list>
          </div>
        </div>
      </div>
    </CardView>
  </div>
</template>

<script>
import FormTaskDefinition from "@/components/taskDefinition/FormTaskDefinition.vue"
import CardView from "@/components/cardView.vue";
import SubtaskList from "@/components/taskDefinition/SubtaskList.vue";
import {mapGetters} from "vuex";
// import firebase from "firebase";

export default {
  name: "taskDefinitionAdd",
  components: {SubtaskList, CardView, FormTaskDefinition},
  props: {},
  methods: {
    async create(taskDefinition) {
      const taskDefinitionId = await this.saveTaskDefinition(taskDefinition)
      await this.saveSubtasks(taskDefinitionId)
      this.$router.push({name: 'task-definitions-overview'})
    },
    async saveSubtasks(taskDefinitionId) {
      for (const [index, subtask] of this.subtasks.entries()) {
         subtask.sequence = index
        let subtaskToSave;

         if (!subtask.id) {

          this.file = subtask.file
          this.fileRecord = subtask.fileRecord
          subtask.fileName = this.file ? this.file.name : null

          subtaskToSave = {
            ..._.omit(subtask,['file','fileRecord']),
            companyId: this.getClaims.companyId,
            taskDefinitionId: taskDefinitionId
          }
        } else {
          subtaskToSave = {
            ..._.omit(subtask,['file','fileRecord']),
          }
        }
        try {
           let docId = await this.$store.dispatch("taskDefinitionSubtasks/set", subtaskToSave);
           if (this.file) {
             const storageRef = this.$FB_STORAGE
                .ref("taskDefinitionSubtasks/"+ this.getClaims.companyId + "/" + docId + "/" + this.file.name);
             await storageRef
                .put(this.file)
                .then(function (res) {
                  console.log(res)
                  console.log("Uploaded successfully");
                })
                .catch((error) => {
                  console.log(error.message);
                });
          }
        } catch (e) {
          throw e
        }
      }
      this.swalToastSuccess(this.$t("ui.saved"))
    },
    async saveTaskDefinition(taskDefinition) {
      let taskDefinitionToSave = {
        ...taskDefinition,
        amountOfSubtasks: this.subtasks.length,
        companyId: this.getClaims.companyId,
      }
      let docId = await this.$store.dispatch("taskDefinitions/set", taskDefinitionToSave);
      console.log("SaveTaskDefinition: ", taskDefinitionToSave, "; ", docId)
      return docId
    },
  },
  computed: {
    ...mapGetters('users', ['getClaims', 'getSelectedWorkflow']),
  },
  data() {
    return {
      subtasks: [],
      taskDefinition: null,
    }
  },
}
</script>

<style scoped>

</style>